import React, { useContext, useEffect, useState } from 'react'
import { HeaderMenu } from '../../component/HeaderMenu'
import AsyncSelect from 'react-select/async';
import { URL_SRV_RAIZ } from '../../router/Url';
import LoginContext from '../../context/login_context/LoginContext';
import { Alert, Button, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, Switch, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

// ICONS
import AttachmentIcon from '@mui/icons-material/Attachment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { ModalLoaded } from '../../component/ModalLoaded.component';
import { CreaSolicitud } from '../../api/CreaSolicitud.api';//ok
import { UploadFile } from '../../api/UploadFile.api';//ok
import { cleanDigitSectionValue } from '@mui/x-date-pickers/internals/hooks/useField/useField.utils';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  padding:0,
  margin:0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export const SolicitudesDeTrabajo = () => {

  const {LoginState} = useContext(LoginContext);
  // console.log(LoginState);
  const [SelMaq, setSelMaq] = useState('');
  const [DScrtec, setDScrtec] = useState('');
  const [Observacion, setObservacion] = useState('');
  const [FileData, setFileData] = useState({file:{}, filename:'', file_:{}});
  const [IsUrgente, setIsUrgente] = useState(false);
  const [tipo, setTipo] = useState('');

  const [PreviewImage, setPreviewImage] = useState('');

  const [IsComplete, setIsComplete] = useState(true);
  const [ModalLoadded, setModalLoadded] = useState(false);

  const [TipoDeSolicitud, setTipoDeSolicitud] = useState("");

  const [PlazoLlegadaREquerido, setPlazoLlegadaREquerido] = useState({cantidad:'', tipo:''});



  const promiseOptionsEquipos = async (inputValue) =>
    new Promise(async(resolve) => {
      if(inputValue.length >= 3){
        let query = await fetch(URL_SRV_RAIZ+'getequipos_fracttal',{
          method: "POST",
          headers: {
            'authorization': "marcuxo",
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            TEXT:inputValue.toUpperCase(),
            PLANTA: LoginState.planta.toUpperCase()
          })
        })

        let responsio = await query.json();
        // console.log(responsio)
        resolve(responsio.item)
      }else{
        resolve(null)
      }
    
  });

   
  // console.log(new Date().getTime().toString());
  const CrearSolicitudDeTrabajo = async () => {
    await setModalLoadded(true)
    // console.log(SelMaq?.value, DScrtec, LoginState.rut, Observacion);
    let u_file = 'imagen'
    if(FileData.filename){
      u_file = await UploadFile({taskID: new Date().getTime().toString(), file:FileData.file, planta:LoginState.planta})
    }
    // console.log(u_file);
    // console.log('debe salir despues de cargar la foto');
    
    // console.log({
    //   type_1: tipo,
    //   code: SelMaq?.value, // AGP LIGADO A LA TAREA
    //   description:"OBSERVACIONES: "+ DScrtec, // OBSERVACIONES + NOMBREE DE LA TAREA
    //   comment: Observacion+"\n"+u_file, // NEGATICO + OBSERVACION OBLIGATORIA
    //   name: LoginState.user, // NOMBRE USUARIO LOGUEADO NO RUT
    //   reference: '', // NUMERO DE OT
    //   is_urgent: IsUrgente, // URGENCIA DE SOLICITUD
    //   planta:LoginState.planta
    // })

    // modulo que crea una solicitud en fracttal
    await CreaSolicitud({
      type_1: tipo,
      code: SelMaq?.value, // AGP LIGADO A LA TAREA
      description:"["+TipoDeSolicitud+"] \nOBSERVACIONES: "+ DScrtec, // OBSERVACIONES + NOMBREE DE LA TAREA
      comment: Observacion+"\n"+u_file, // NEGATIVO + OBSERVACION OBLIGATORIA
      name: LoginState.user, // NOMBRE USUARIO LOGUEADO NO RUT
      reference: '', // NUMERO DE OT
      is_urgent: IsUrgente, // URGENCIA DE SOLICITUD
      planta:LoginState.planta
    })
   
    const sendMail = async (to_) => {
      await fetch('https://spc-back.apidev.info/api/mailer/sendmail', {
        method: 'POST',
        headers: {
          'authorization': "marcuxo",
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify({
          "name": "Solicitud de Trabajo",
          "email": to_,
          "email_cc": "murrutiam@ariztia.com",
          "subject": `SOLICITUD DE TRABAJO ${tipo} - ${LoginState.planta}`,
          "body": `<h1>SOLICITUD DE TRABAJO ${tipo} - ${LoginState.planta} urgente </h1></br></br>
          <ul>
          <li>DESCRIPCIÓN: ${DScrtec}</li>
          <li>OBSERVACIONES: ${Observacion}</li>
          <li>MAQUINA: ${SelMaq?.label}</li>
          <li>SOLICITANTE: ${LoginState?.user}</li>
          </ul>`,
          "file": null
        }),
      })
      .then(response => response.json())
      .then(data => {
        console.log('Success:', data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }

    if(IsUrgente){
      if(LoginState.planta === "PAICO"){
        if(tipo === "ELECTRICO"){
          // enviar correo a electrico urgente
          //mafuentes@ariztia.com
          await sendMail("mafuentes@ariztia.com;abarrera@ariztia.com;")
        }
        if(tipo === "MECANICO"){
          // enviar correo a mecanico urgente
          //acordova@ariztia.com
          await sendMail("acordova@ariztia.com;abarrera@ariztia.com;")
        }
        if(tipo === "REFRIGERACION"){
          // enviar correo a refrigeracion urgente
          //amelillan@ariztia.com
          await sendMail("amelillan@ariztia.com;abarrera@ariztia.com;")
        }
      }
      if(LoginState.planta === "ARICA"){
        if(tipo === "ELECTRICO" || tipo === "MECANICO"){
          // enviar correo a electrico urgente
          //miespinoza@ariztia.com
          await sendMail("miespinoza@ariztia.com")
        }
        if(tipo === "REFRIGERACION"){
          // enviar correo a refrigeracion urgente
          //gcanaviri@ariztia.com
          await sendMail("gcanaviri@ariztia.com")
        }
      }
      if(LoginState.planta === "OCHAGAVIA"){
        if(tipo === "ELECTRICO"){
          // enviar correo a electrico urgente
          await sendMail("melecoch@ariztia.com")
        }
        if(tipo === "MECANICO"){
          // enviar correo a mecanico urgente
          await sendMail("fareyes@ariztia.com")
        }
        if(tipo === "REFRIGERACION"){
          // enviar correo a refrigeracion urgente
          await sendMail("rcisterna@ariztia.com")
        }
      }
      // if(LoginState.planta === "MONTINA"){
      //   if(tipo === "ELECTRICO"){
      //     // enviar correo a electrico urgente
      //     f_data.append('email',"mafuentes@ariztia.com")
      //     await sendMail()
      //   }
      //   if(tipo === "MECANICO"){
      //     // enviar correo a mecanico urgente
      //     f_data.append('email',"mafuentes@ariztia.com")
      //     await sendMail()
      //   }
      //   if(tipo === "REFRIGERACION"){
      //     // enviar correo a refrigeracion urgente
      //     f_data.append('email',"mafuentes@ariztia.com")
      //     await sendMail()
      //   }
      // }
    }
    alert(" Se ha creado la solicitud de trabajo")
    setSelMaq('');
    setTipo('')
    setDScrtec('');
    setObservacion('');
    setFileData({file:{}, filename:''});
    setIsUrgente(false);
    setTipoDeSolicitud('');
    setTimeout(() => {
      setModalLoadded(false);
    }, 3000);
  }

  const SendCorreoFaltaRepuesto = async () => {
    console.log("enviar correo falta de repuesto");
    let data = new FormData();
    data.append("file", FileData?.file);
    const sendMail_ = async (to_) => {
      await fetch('https://spc-back.apidev.info/api/mailer/sendmail', {
        method: 'POST',
        headers: {
          'authorization': "marcuxo",
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify({
          "name": "Falta de Repuesto",
          "email": to_,
          "email_cc": "murrutiam@ariztia.com",
          "subject": `FALTA DE REPUESTO ${tipo} - ${LoginState.planta}`,
          "body": `<h1>FALTA DE REPUESTO ${tipo} - ${LoginState.planta} </h1></br></br>
          <ul>

          <li>OBSERVACIONES: ${Observacion}</li>
          <li>MAQUINA: ${SelMaq?.label}</li>
          <li>PLAZO DE LLEGADA: ${PlazoLlegadaREquerido.cantidad} ${PlazoLlegadaREquerido.tipo}</li>
          <li>SOLICITANTE: ${LoginState?.user}</li>
          </ul>`,
          "file": data
        }),
      })
      .then(response => response.json())
      .then(data => {
        // console.log('Success:', data);
        return
      })
      .catch((error) => {
        // console.error('Error:', error);
        return
      });
    }

    // await sendMail_("murrutiam@ariztia.com")
    alert(" Se ha enviado la solicitud de falta de repuesto por correo")
    let UrgentJM_P = ";vgomez@ariztia.com;"
    let UrgentJM_A = ";myanezd@ariztia.com;"
    let UrgentJM_O = ";nrojas@ariztia.com;"
    if(LoginState.planta === "PAICO"){
      if(tipo === "ELECTRICO"){
        // enviar correo a electrico urgente
        //mafuentes@ariztia.com
        await sendMail_("mafuentes@ariztia.com" + (IsUrgente ? UrgentJM_P : ";"))
      }
      if(tipo === "MECANICO"){
        // enviar correo a mecanico urgente
        //acordova@ariztia.com
        await sendMail_("acordova@ariztia.com" + (IsUrgente ? UrgentJM_P : ";"))
      }
      if(tipo === "REFRIGERACION"){
        // enviar correo a refrigeracion urgente
        //amelillan@ariztia.com
        await sendMail_("amelillan@ariztia.com" + (IsUrgente ? UrgentJM_P : ";"))
      }
    }
    if(LoginState.planta === "ARICA"){
      if(tipo === "ELECTRICO" || tipo === "MECANICO"){
        // enviar correo a electrico urgente
        //miespinoza@ariztia.com
        await sendMail_("miespinoza@ariztia.com" + (IsUrgente ? UrgentJM_A : ";"))
      }
      if(tipo === "REFRIGERACION"){
        // enviar correo a refrigeracion urgente
        //gcanaviri@ariztia.com
        await sendMail_("gcanaviri@ariztia.com" + (IsUrgente ? UrgentJM_A : ";"))
      }
    }
    if(LoginState.planta === "OCHAGAVIA"){
      if(tipo === "ELECTRICO"){
        // enviar correo a electrico urgente
        await sendMail_("melecoch@ariztia.com" + (IsUrgente ? UrgentJM_O : ";"))
      }
      if(tipo === "MECANICO"){
        // enviar correo a mecanico urgente
        await sendMail_("fareyes@ariztia.com" + (IsUrgente ? UrgentJM_O : ";"))
      }
      if(tipo === "REFRIGERACION"){
        // enviar correo a refrigeracion urgente
        await sendMail_("rcisterna@ariztia.com" + (IsUrgente ? UrgentJM_O : ";"))
      }
    }
    // if(LoginState.planta === "MONTINA"){
    //   if(tipo === "ELECTRICO"){
    //     // enviar correo a electrico urgente
    //     f_data.append('email',"mafuentes@ariztia.com")
    //     await sendMail()
    //   }
    //   if(tipo === "MECANICO"){
    //     // enviar correo a mecanico urgente
    //     f_data.append('email',"mafuentes@ariztia.com")
    //     await sendMail()
    //   }
    //   if(tipo === "REFRIGERACION"){
    //     // enviar correo a refrigeracion urgente
    //     f_data.append('email',"mafuentes@ariztia.com")
    //     await sendMail()
    //   }
    // }

    setSelMaq('');
    setTipo('')
    setDScrtec('');
    setObservacion('');
    setFileData({file:{}, filename:''});
    setIsUrgente(false);
    setTipoDeSolicitud('');
    setTimeout(() => {
      setModalLoadded(false);
    }, 3000);
  }

  const SendNovedadForEmail = async () => {
    const sendMail_ = async (to_) => {
      await fetch('https://spc-back.apidev.info/api/mailer/sendmail', {
        method: 'POST',
        headers: {
          'authorization': "marcuxo",
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify({
          "name": "Novedad",
          "email": to_,
          "email_cc": "murrutiam@ariztia.com",
          "subject": `NOVEDAD ${tipo} - ${LoginState.planta}`,
          "body": `
          <style>
            .dv1 {
              width: 100%;
              border-left: 5px solid rgb(22, 11, 83);
              padding: 15px 5px;
              background-color: #eceafd;
              border-radius: 0px 5px 5px 0px;
            }
            .dv2 {
              width: 100%;
              border-left: 5px solid rgba(3, 11, 255, 1);
              padding: 15px 5px;
              background-color: rgba(252, 222, 157, 1);
              border-radius: 0px 5px 5px 0px;
            }
          </style>
          <div class="dv1">
            <h1>NOVEDAD ${tipo} - ${LoginState.planta} </h1>
          </div>

          </br>
          </br>
          <div class="dv2">
            <ul>
              <li>DESCRIPCIÓN: ${DScrtec}</li>
              <li>OBSERVACIONES: ${Observacion}</li>
              <li>MAQUINA: ${SelMaq?.label}</li>
              <li>SOLICITANTE: ${LoginState?.user}</li>
            </ul>
          </div>
          `,
          "file": null
        }),
      })
      .then(response => response.json())
      .then(data => {
        // console.log('Success:', data);
        return
      })
      .catch((error) => {
        // console.error('Error:', error);
        return
      });
    }
    alert(" Se ha enviado la novedad por correo")
    await sendMail_("abarrera@ariztia.com;")

    setSelMaq('');
    setTipo('')
    setDScrtec('');
    setObservacion('');
    setFileData({file:{}, filename:''});
    setIsUrgente(false);
    setTipoDeSolicitud('');
    setTimeout(() => {
      setModalLoadded(false);
    }, 3000);
  }

  const SendCorreoSolicitudHerrameinta = async () => {
    alert("enviar correo solicitud de herramienta");
    //metodo funcionando////////////////
    const sendMail_ = async (to_) => {
      let data = new FormData();
      data.set("file", FileData?.file);
      data.set("name", "Novedad");
      data.set("email", to_);
      data.set("email_cc", "murrutiam@ariztia.com");
      data.set("subject", `SOLICITUD DE HERRAMIENTA ${tipo} - ${LoginState.planta}`);
      data.set("body",  `<h1>SOLICITUD DE HERRAMIENTA  ${tipo} - ${LoginState.planta} </h1></br></br>
          <ul>

          <li>DESCRIPCIÓN: ${DScrtec}</li>
          <li>OBSERVACIONES: ${Observacion}</li>
          <li>SOLICITANTE: ${LoginState?.user}</li>
          </ul>
          `);
      console.log(data);
      await fetch('https://spc-back.apidev.info/api/mailer/sendmail', {
        method: 'POST',
        headers: {
          'authorization': "marcuxo",
          'Access-Control-Allow-Origin': '*'
        },
        body: data      
      })
      .then(response => response.json())
      .then(data => {
        console.log('Success:', data);
        return
      })
      .catch((error) => {
        console.error('Error:', error);
        return
      });
    }
    alert(" Se ha enviado la solicitud de herramienta")
    await sendMail_("murrutiam@ariztia.com;")

    setSelMaq('');
    setTipo('')
    setDScrtec('');
    setObservacion('');
    setFileData({file:{}, filename:''});
    setIsUrgente(false);
    setTipoDeSolicitud('');
    setTimeout(() => {
      setModalLoadded(false);
    }, 3000);
  }


  useEffect(() => {
    if(SelMaq === '' || Observacion === ''){
      setIsComplete(true)
      // console.log(true, SelMaq, DScrtec, Observacion, FileData.filename);
    }else{
      setIsComplete(false)
      // console.log(false, SelMaq, DScrtec, Observacion, FileData.filename);
    }
    return () => {
    }
    
  }, [SelMaq, DScrtec, Observacion])

  useEffect(() => {
    setPlazoLlegadaREquerido({cantidad:'', tipo:''})
  
  }, [TipoDeSolicitud])
  

  useEffect(() => {

    // console.log(FileData?.file);
    if(FileData?.filename === "" || FileData?.file === undefined || FileData?.file === null){
      // console.log('no hay archivo');
      setPreviewImage('')
    }else{
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader?.result);
      }
      reader.readAsDataURL(FileData?.file)

    }

  }, [FileData])

  
  
  return (
    <>
      <HeaderMenu Pag_Sel={'solicitudes'} />
     
      <div className='container mt-5'>
        <div className='row'>
          <div className='col-12'>
           
          </div>
          <div className='col-12 d-flex justify-content-start align-items-center mb-3'>
            <span className='lead'>¿Qué deseas hacer?</span>
            <FormControl sx={{ m: 1, minWidth: 120, width: 300 }} size="small">
              <InputLabel id="demo-select-small-label">Selecciona el tipo de solicitud</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                label="Selecciona el tipo de solicitud"
                value={TipoDeSolicitud}
                onChange={(e) => setTipoDeSolicitud(e.target.value)}
              >
                <MenuItem value={"FALTA DE REPUESTO"}>Falta de Repuesto</MenuItem>
                <MenuItem value={"NOVEDAD"}>Novedad</MenuItem>
                <MenuItem value={"SOLICITUD DE TRABAJO"}>Solicitud de Trabajo</MenuItem>
                <MenuItem value={"SOLICITUD DE HERRAMIENTA"}>Solicitud de Herramienta</MenuItem>
              </Select>
            </FormControl>
          </div>
          {
            TipoDeSolicitud === "FALTA DE REPUESTO"?
              <div className='col-12 col-md-6'>
                <div className='col-12 card_form' onClick={!TipoDeSolicitud?()=>{alert('Seleccione el tipo de solicitud')}:null}>
                  <div className='row'>
                    <div className='col-12'>
                      <label>Plazo llegada requerido</label>
                    </div>
                    <div className='col-6'>
                      <label>Cantidad</label>
                      <input
                        style={{width: '100%', height: '38px', borderRadius: '5px', border: '1px solid #C4C4C4', paddingLeft: '10px'}}
                        disabled={!TipoDeSolicitud}
                        size='small'
                        id="outlined-textarea"
                        // label="Descripcion Tecnica"
                        type='number'
                        multiline={true}
                        value={PlazoLlegadaREquerido.cantidad}
                        onChange={(e)=>e.target.value>=0?setPlazoLlegadaREquerido({...PlazoLlegadaREquerido, ['cantidad']:e.target.value}):null}
                      />
                    </div>
                    <div className='col-6'>
                      <label>Tipo de Plazo</label><br/>
                      <FormControl fullWidth size="small">
                        <Select
                          labelId="demo-select-small-label"
                          id="demo-select-small"
                          value={PlazoLlegadaREquerido.tipo}
                          onChange={(e)=>setPlazoLlegadaREquerido({...PlazoLlegadaREquerido, ['tipo']:e.target.value})}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value={"Días"}>Días(s)</MenuItem>
                          <MenuItem value={"Semanas"}>Semanas(s)</MenuItem>
                          <MenuItem value={"Mes"}>Mes(es)</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </div>
            :
              <div className='col-12 col-md-6'>
                <div className='col-12 card_form' onClick={!TipoDeSolicitud?()=>{alert('Seleccione el tipo de solicitud')}:null}>
                  <label>Descripción Técnica</label>
                  <TextField
                    disabled={!TipoDeSolicitud}
                    style={{backgroundColor: '#fff'}}
                    fullWidth
                    size='small'
                    id="outlined-textarea"
                    // label="Descripcion Tecnica"
                    placeholder={TipoDeSolicitud === "SOLICITUD DE HERRAMIENTA"?"EJ: JUEGO DE LLAVES ALLEN RODADAS Y EN MAL ESTADO":"EJ:RODAMIENTO CON RUIDO EXTRAÑO..."}
                    multiline={true}
                    value={DScrtec}
                    onChange={(e)=>setDScrtec(e.target.value.toUpperCase())}
                  />
                </div>
              </div>
          }

          {/* MAQUINA O EQUIPO */}
          {
            TipoDeSolicitud === "SOLICITUD DE HERRAMIENTA"?null:
          <div className='col-12 col-md-6 ' onClick={!TipoDeSolicitud?()=>{alert('Seleccione el tipo de solicitud')}:null}>
            <div className='col-12 card_form'>
              <label>Busque y Seleccione Máquina o Equipo</label>
              <AsyncSelect isDisabled={!TipoDeSolicitud} isClearable isSearchable  placeholder={'BUSCAR EQUIPO'} value={SelMaq} onChange={(e)=>setSelMaq(e?e:'')} loadOptions={promiseOptionsEquipos} />
            </div>
          </div>
          }

          {/* OBSERVACION */}
          <div className='col-12 col-md-6' onClick={!TipoDeSolicitud?()=>{alert('Seleccione el tipo de solicitud')}:null}>
            <div className='col-12 card_form'>
              <label>Observación</label>
              <TextField
                disabled={!TipoDeSolicitud}
                style={{backgroundColor: '#fff'}}
                fullWidth
                size='small'
                id="outlined-textarea"
                // label="Descripcion Tecnica"
                placeholder={TipoDeSolicitud === "SOLICITUD DE HERRAMIENTA"?"EJ: REEMPLAZAR JUEGO DE LLAVES ALLEN EN MAL ESTADO":"EJ: REEMPLAZAR RODAMIENTO 206 2RS ..."}
                multiline={true}
                value={Observacion}
                onChange={(e)=>setObservacion(e.target.value.toUpperCase())}
              />
            </div>
          </div>

          {/* TIPO DE SOLICITUD */}
          <div className='col-12 col-md-6 autocenter' onClick={!TipoDeSolicitud?()=>{alert('Seleccione el tipo de solicitud')}:null}>
            <div className='col-12 card_form'>
              <label>Tipo de {TipoDeSolicitud === "FALTA DE REPUESTO"?"Repuesto":
              TipoDeSolicitud === "SOLICITUD DE HERRAMIENTA"?"Herramienta":"Trabajo"}</label>
              <FormControl fullWidth>
              {/* <InputLabel id="demo-simple-select-label" size='small'>Selecione Maquina o Equipo</InputLabel> */}
              <Select
                disabled={!TipoDeSolicitud}
                style={{backgroundColor: '#fff'}}
                size='small'
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={tipo}
                onChange={(e)=>setTipo(e.target.value)}
              >
                {/* <MenuItem value={"ADMINISTRATIVO"}>Administrativo</MenuItem> */}
                <MenuItem value={"ELECTRICA"}>Eléctrica</MenuItem>
                {/* <MenuItem value={"EXTERNO"}>Externo</MenuItem> */}
                <MenuItem value={"MECANICA"}>Mecánica</MenuItem>
                <MenuItem value={"REDES Y SERVICIOS"}>Redes y Servicios Eléctricos</MenuItem>
                <MenuItem value={"SALA DE MAQUINAS"}>Sala de Máquinas</MenuItem>
                <MenuItem value={"SERVICIOS VARIOS"}>Servicios Varios</MenuItem>
                <MenuItem value={"SUPERVISOR"}>Supervisor</MenuItem>
              </Select>
              </FormControl>
            </div>
          </div>

          {/* ADJUNTAR IMAGEN */}
          <div className='col-12 col-md-6 text-break text-center'>
            <div className='col-12 card_form'>
              <p>Adjuntar imagen.</p>
              <Button  component="label" color='secondary' variant="contained">
                {
                  FileData?.filename!==""?FileData?.filename:<AttachmentIcon />
                }
                <VisuallyHiddenInput
                  accept='image/jpeg'
                  type="file"
                  onChange={(e)=>{
                    // console.log(e.target.files[0]);
                    setFileData({...FileData, ['filename']:e.target.files[0]?.name||"",['file']:e.target.files[0]||{},['file_']:e.target.files})
                  }}
                />
              </Button>
              <p style={{color:'#CACACA', margin:0, fontSize: 'small'}}>Max. 2MB</p>
            </div>
          </div>

          {/* ES URGENTE */}
          <div className='col-12 col-md-6  text-break text-center'>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    value={IsUrgente}
                    color='error'
                    onChange={(e)=>setIsUrgente(e.target.checked)}
                  />}
                label="Es Urgente" />
            </FormGroup>
          </div>

          {/* PREVIEW IMAGEN */}
          <div className='col-12 my-3 col-md-6 text-break text-center'>
              {
                FileData?.filename!==""?<>
                <img className='img-hover' src={PreviewImage} alt="preview" />
                <p>{FileData?.filename}</p>
                </>
                :null
              }
          </div>

          {/* BOTON CREAR SOLICITUD */}
          <div className='col-12 col-md-6 text-right text-center my-5'>
            <button
              disabled={TipoDeSolicitud === "" || Observacion === "" ? true : false}
              className='btn btn-sm btn-success'
              onClick={()=>TipoDeSolicitud === "FALTA DE REPUESTO"?SendCorreoFaltaRepuesto():
              TipoDeSolicitud === "NOVEDAD"?SendNovedadForEmail():
              TipoDeSolicitud === "SOLICITUD DE HERRAMIENTA"?SendCorreoSolicitudHerrameinta():CrearSolicitudDeTrabajo()}
            ><ReceiptLongIcon/> {TipoDeSolicitud === "FALTA DE REPUESTO"?"ENVIAR FALTA DE REPUESTO":
              TipoDeSolicitud === "NOVEDAD"?"ENVIAR NOVEDAD":
              TipoDeSolicitud === "SOLICITUD DE HERRAMIENTA"?"ENVIAR SOLICITUD DE HERRAMIENTA":"CREAR SOLICITUD DE TRABAJO"}</button>
          </div>
        </div>
      </div>
      {/* <button onClick={()=>console.log(IsUrgente)}>boton!!</button> */}
        {
          ModalLoadded?<ModalLoaded texto={'En estos momentos se esta creando la solicitud, por favor espere!!'} />:null
        }

    </>
  )
}